import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { registerToolRendererGroup } from "../util/shapeCategorySingleton";
import { strokeCorrection } from "../util/strokeCorrection";
import BaseLine from "../shapes/line/LineBase";
import { Transform } from "../../../geometry/transformation";
import { RootState } from "../../../store/store";
import { modelReplaceMultipleShapes } from "../../../store/model";
import { endRubberline } from "../../../store/interaction";
import RenderSelection from "../util/RenderSelection";
import { pointEquals } from "../../../geometry/operation";
import { useSnapMousePosition } from "./useSnapMousePosition";
import { transformShape } from "../util/shapeEdit";

const MoveSymbol = () => {
    const dispatch = useAppDispatch();
    const selectionIds = useAppSelector((state: RootState) => state.model.present.selected.selectedItemIds)
    const shapes = useAppSelector((state: RootState) => state.model.present.model.shapes);
    const interaction = useAppSelector((state: RootState) => state.interaction)
    const scale = useAppSelector((state: RootState) => state.interface.viewport.scale)
    const mousePosition = useAppSelector((state: RootState) => state.interface.mousePosition);
    const defaultLineSetting = useAppSelector((state: RootState) => state.tool.toolSettings.move.symbolLine);
    const selectedShapes = shapes.filter((shape: GeometricShape) => selectionIds.find((selectionId) => shape.id === selectionId) !== undefined);
    const mousePositionSnap = useSnapMousePosition();

    // Modify Line properties for use of rotation symbol
    const internalLineProperties = {
        ...defaultLineSetting,
        id: -1,
        strokeWidth: strokeCorrection(defaultLineSetting.strokeWidth, scale),
        points: interaction.rubberlineData.snapPoints.concat(mousePositionSnap),
        draggable: false,
    }
    // Points coming from clicks on the stage
    const pointBuffer = interaction.rubberlineData.snapPoints;
    const moveTransformation = pointBuffer[0] && !pointEquals(pointBuffer[0], mousePosition) ?
        Transform.translationTransform(
            mousePositionSnap.x - pointBuffer[0].x,
            mousePositionSnap.y - pointBuffer[0].y
        ) :
        new Transform();
    switch (pointBuffer.length) {
        case 0: {

            break;
        }

        case 1: {
            return <>
                <BaseLine shapeProps={internalLineProperties} />
                <RenderSelection selectedItems={selectedShapes} transform={moveTransformation} />
            </>
        }

        case 2: {

            if (selectedShapes) {
                const newShapeList = selectedShapes.map((shape) => transformShape(shape, moveTransformation))
                dispatch(modelReplaceMultipleShapes(newShapeList))
                dispatch(endRubberline());
            }
            break;
        }
        default:
            console.log("valami itt ");

            dispatch(endRubberline())
            break;
    }

    return (<></>)
}
const createMoveSymbol = () => {

    return (<MoveSymbol />)
}
export { createMoveSymbol }
registerToolRendererGroup("move", { toolRender: createMoveSymbol })